import React from 'react';
import AtmoDemo from 'components/atmo-demo';

const AtmoDemoPage = () => (
  <div className="l-demo-content">
    <AtmoDemo />
  </div>
);

export default AtmoDemoPage;



// WEBPACK FOOTER //
// ./src/pages/products/tools/demo/component.js